import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import style from './style.css';

const Item = (props = {}) => {
  const { image, label, link, color } = props;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={style.container}
      style={{ background: color }}
    >
      <img src={image} alt={label} className={style.image} />
      <div className={style.textContainer}>
        <span className={style.text}>{label}</span>
        <div className={style.icon}>
          <Icon color="white" viewBox="0 0 24 24" icon="external-link-square-alt" size="small" />
        </div>
      </div>
    </a>
  );
};

Item.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

Item.defaultProps = {};

export default Item;
